import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAdministrationCausesPrincipales } from 'store/administration/administrationActions';
import { patchCausePrincipale } from 'store/administration/administrationActions';
import AdministrationCausePrincipale from './AdministrationCausePrincipale';
import withLoader from 'components/Shared/withLoader';

const AdministrationCausePrincipaleWithLoader = withLoader(AdministrationCausePrincipale);

class AdministrationCausePrincipaleContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            causePrincipale: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationCausesPrincipales({ avecNbActions: false });

        let { id, causesPrincipales } = this.props;

        if (id && id !== 0) {
            let causePrincipale = causesPrincipales.find(x => x.id === id);
            

            this.setState({
                causePrincipale: JSON.parse(JSON.stringify(causePrincipale))
            });
        }
    }
           


    handleChange = (event) => {
        let newCausePrincipale = this.state.causePrincipale;

        if (event.target.name === 'libelle') {
            newCausePrincipale.libelle = event.target.value;
        }
        
        this.setState({ ...this.state, causePrincipale: newCausePrincipale });
    };





    handleClickCancel = (event) => {
        this.setState({
            causePrincipale: null
        });
    };

    handleClickSave = async (event, id) => {
        await this.props.patchCausePrincipale(this.state.causePrincipale);
        this.setState({
            causePrincipale: null
        });
    };



    handleChangeDetail = (index, value) => {
        var newState = { ...this.state };
        newState.causePrincipale.details[index].libelle = value;
        this.setState(newState);
    };


    handleClickAddDetail = () => {
        this.setState({
            ...this.state,
            causePrincipale: {
                ...this.state.causePrincipale,
                details: [...this.state.causePrincipale.details, { libelle: 'nouveau détail' }]
            }
        });
    };


    handleClickRemoveDetail = (index) => {
        var newState = { ...this.state };
        newState.causePrincipale.details.splice(index, 1);
        this.setState(newState);
    };


    render() {
        const { isLoading, isPatching, causesPrincipales} = this.props;
        const { causePrincipale } = this.state;

        let sauvegardable = !causePrincipale || (causePrincipale.libelle.length > 0);


        return (
            <AdministrationCausePrincipaleWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                causesPrincipales={causesPrincipales}
                
                selectedCausePrincipale={causePrincipale}

                onChange={this.handleChange}
                onClickCancel={this.handleClickCancel}
                onClickSave={this.handleClickSave}         

                onClickAddDetail={this.handleClickAddDetail}
                onClickRemoveDetail={this.handleClickRemoveDetail}
                onChangeDetail={this.handleChangeDetail}
                

                sauvegardable={sauvegardable}
            />);
    }
}

AdministrationCausePrincipaleContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = state => ({
    isLoading: state.administration.causesPrincipales.isLoading,
    isPatching: state.administration.causesPrincipales.isPatching,
    causesPrincipales: state.administration.causesPrincipales.items
});

const mapDispatchToProps = dispatch => ({
    fetchAdministrationCausesPrincipales: (param) => dispatch(fetchAdministrationCausesPrincipales(param)),
    patchCausePrincipale: (causePrincipale) => dispatch(patchCausePrincipale(causePrincipale))    
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationCausePrincipaleContainer);